import { useAccount } from '@/domain/hooks/useAccount'
import { usePointsLeaderboard } from './usePointsLeaderboard'
import { useChainId } from 'wagmi'

export function useUserRank() {
  const chainId = useChainId()
  const account = useAccount()
  const { data } = usePointsLeaderboard({ chainId })

  const userRank = data?.find((item) => item.recipient.toLowerCase() === account?.toLowerCase())?.ranking

  return {
    userRank,
  }
}
